import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import "../../../../afs-walkthrough.css";
import WComponent from "../../../../../../../common/WComponent";
import UtilityService from "../../../../../../../../services/UtilityService";

let SECTION_ORDER = ["ASSET", "LIABILITY", "EQUITY", "REVENUE", "CONTRA_REVENUE", "COST_OF_SALES", "EXPENSE"];
let SECTION_LABELS = {
	ASSET: "Assets",
	LIABILITY: "Liabilities",
	EQUITY: "Equity",
	REVENUE: "Revenue",
	CONTRA_REVENUE: "Contra Revenue",
	COST_OF_SALES: "Cost of Sales",
	EXPENSE: "Expenses",
};

class TrialBalanceQuickView extends WComponent {
	state = { filter: "", collapsed: {} };

	render() {
	let { crossCheckFacts, onClose, onSearchGL } = this.props;
	let { filter, collapsed } = this.state;

	let entries = (crossCheckFacts && crossCheckFacts.allEntries) || [];

	let grouped = (function () {
		let q = (filter || "").trim().toLowerCase();
		let groups = {};

		for (let entry of entries) {
			if (Math.abs(entry.net_balance) < 1) continue;
			let major = entry.rollup_major || "OTHER";
			if (q && !(entry.display_name || "").toLowerCase().includes(q) && !(entry.canonical_code || "").toLowerCase().includes(q)) continue;
			if (!groups[major]) groups[major] = { entries: [], subtotal: 0 };
			groups[major].entries.push(entry);
			groups[major].subtotal += entry.net_balance;
		}

		return groups;
	})();

	let totalDebit = 0;
	let totalCredit = 0;
	for (let entry of entries) {
		totalDebit += entry.debit_total || 0;
		totalCredit += entry.credit_total || 0;
	}
	let netIncome = (crossCheckFacts && crossCheckFacts.netIncome) || 0;

	let fmtBal = function (val) {
		if (val == null) return "—";
		const formattedBalance = UtilityService.formatDollarBalance({ balance: val, decimalPlaces: 0 });
		return formattedBalance;
	};

	const toggleSection = (major) => {
		this.setState(function (prev) { return { collapsed: { ...prev.collapsed, [major]: !prev.collapsed[major] } }; });
	};

	return (
		<div className="afs-tb-view">
			<div className="afs-tb-view__header">
				<div className="afs-tb-view__header-title"><Icon.List size={16} /><span>Trial Balance</span></div>
				<button className="afs-tb-view__close" onClick={onClose}><Icon.X size={16} /></button>
			</div>

			<div className="afs-tb-view__search-bar">
				<input className="afs-tb-view__search-input" type="text" placeholder="Filter accounts..." value={filter} onChange={(e) => { this.update({ filter: e.target.value }); }} />
			</div>

			<div className="afs-tb-view__list">
				{SECTION_ORDER.map(function (major) {
					let group = grouped[major];
					if (!group || group.entries.length === 0) return null;
					let isCollapsed = collapsed[major];
					let label = SECTION_LABELS[major] || major;

					return (
						<div key={major} className="afs-tb-view__section">
							<div className="afs-tb-view__section-header" onClick={function () { toggleSection(major); }}>
								{isCollapsed ? <Icon.ChevronRight size={14} /> : <Icon.ChevronDown size={14} />}
								<span className="afs-tb-view__section-label">{label}</span>
								<span className="afs-tb-view__section-total">{fmtBal(group.subtotal)}</span>
							</div>
							{!isCollapsed && group.entries.map(function (entry) {
								return (
									<div key={entry.canonical_code} className="afs-tb-view__entry" onClick={function () { if (onSearchGL) onSearchGL(entry.display_name || entry.canonical_code); }}>
										<span className="afs-tb-view__entry-name">{entry.display_name}</span>
										<span className={clsx("afs-tb-view__entry-balance", entry.net_balance < 0 && "afs-tb-view__entry-balance--negative")}>{fmtBal(entry.net_balance)}</span>
									</div>
								);
							})}
						</div>
					);
				})}
			</div>

			<div className="afs-tb-view__footer">
				<div className="afs-tb-view__footer-row">
					<span>Net Income</span>
					<span className="afs-tb-view__footer-amount">{fmtBal(netIncome)}</span>
				</div>
				<div className="afs-tb-view__footer-row afs-tb-view__footer-row--totals">
					<span>Total DR: {fmtBal(totalDebit)}</span>
					<span>Total CR: {fmtBal(totalCredit)}</span>
					<span>Diff: {fmtBal(Math.abs(totalDebit - totalCredit))}</span>
				</div>
			</div>
		</div>
	);
	}
}

export default TrialBalanceQuickView;
